import { HttpResponse } from '@angular/common/http';

export interface DownloadedFile {
  blob: Blob;
  fileName?: string;
}

export function extractFileNameAndBlob(
  httpResponse: HttpResponse<ArrayBuffer>
): DownloadedFile {
  const headers = httpResponse.headers;
  const contentDisposition = 'filename=posicaoSumarizada.csv'; //headers.get('Content-Disposition');

  if (contentDisposition == null) {
    throw new Error(`Server Error: Cannot retrieve file name.
      Either Content-Dispostion header is not available or it is not exposed using Access-Control-Expose Header.`);
  }

  const fileNameItem = contentDisposition
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.toLowerCase().startsWith('filename='));
  if (fileNameItem == null) {
    throw new Error(`Server didn't send a filename`);
  }

  let fileName = fileNameItem.split('=')[1] ?? 'posicaoSumarizada.csv';
  if (fileName.startsWith('"'))
    fileName = fileName.substring(1, fileName.length - 1);

  const contentType = headers.get('Content-Type');
  let blob: any;
  if (httpResponse.body != null) {
    blob = new Blob([httpResponse.body], { type: contentType ?? '' });
  }
  let response: DownloadedFile = {
    blob: blob,
    fileName: fileName,
  };
  return response;
}
